<template>
  <div class="auth">
    <div class="container">
      <div class="auth__wrapper">
        <div class="auth__block">
          <p class="auth__block-text">{{ t('reset.block.text') }}</p>
        </div>
        <reset-password-form />
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import ResetPasswordForm from "@/components/forms/reset-password-form.vue";

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.auth {
  padding-block: 75px;

  &__wrapper {
    width: 80%;
    margin-inline: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  &__block {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;

    &-text {
      width: 475px;
      color: #5A5A5A;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      line-height: 25.6px;
    }
  }
}

@media (max-width: 550px) {
  .auth {
    &__block {
      &-text {
        width: 100%;
      }
    }
  }
}
</style>